const {Math} = globalThis;

/** Generiert eine zufällige ganze Zahl.
 * @alias task.getRandomInt
 * @param {number} [min=0]
 * @param {number} [max=1.000.000]
 * @return {number}
 */
export default function(min = 0, max = 1000000)
{
    return ~~((Math.random() * (max - min + 1)) + min);
}
